<template>
  <div>
    <p-button
      type="info"
      simple
      class="p-0"
      id="parc-list"
      title="Afficher la liste des parcs"
    >
      <router-link :to="{ path: '/parc-list' }">Retour</router-link>
      <b-tooltip target="#parc-list">
        Afficher la liste des parcs
      </b-tooltip>
    </p-button>

    <!-- Alertes -->
    <b-alert :model-value="true" class="rounded mt-3" variant="info" show v-if="loading">
      <b-spinner small label="Small Spinner"></b-spinner>
      <span class="ms-2">
        Chargement du parc...
      </span>
    </b-alert>

    <div v-else-if="!loading && isParc && isProjection">
      <div class="title text-center">
        <h2 class="mt-1 mb-5">{{ parc.nomUsuel }}</h2>
      </div>
      <div class="row" v-if="!this.loading">
        <div class="col-md-6">
          <parc-card @reload-parc="reloadParc" />
          <parc-dates/>
          <parc-renouvellement @reload-parc="reloadParc"/>
        </div>
        <div class="col-md-6">
          <eolienne-list @reload-parc="reloadParc" />
          <poste-livraison-list @reload-parc="reloadParc" />
        </div>
      </div>
    </div>

    <div v-else>
      <!-- Alertes -->
      <b-alert :model-value="!loading" class="rounded mt-3" variant="danger" show>
        <i class="ti-alert me-2"></i>
        <span>
          Le parc n'a pas pu être chargé.
          <span v-if="!isProjection">Le système de projection du parc n'est pas défini.</span>
          <span v-else>Vous pouvez tenter de réactualiser la page.</span>
        </span>
      </b-alert>
    </div>
  </div>
</template>
<script>
import {parcService} from "@/service/parc.service.js";
import {aerogenerateurService} from "@/service/aerogenerateur.service.js";
import {posteLivraisonService} from "@/service/posteLivraison.service.js";
import {
  ParcProfileDates,
  ParcProfileDatesRenouvellement,
  ParcProfileEolienneList,
  ParcProfileParcCard,
  ParcProfilePosteLivraisonList
} from "@/components/index";

import {mapGetters} from "vuex";
import {BAlert, BSpinner, BTooltip} from "bootstrap-vue-next";

export default {
  components: {
    BTooltip,
    BAlert,
    BSpinner,
    ParcCard: ParcProfileParcCard,
    ParcDates: ParcProfileDates,
    ParcRenouvellement: ParcProfileDatesRenouvellement,
    EolienneList: ParcProfileEolienneList,
    PosteLivraisonList: ParcProfilePosteLivraisonList
  },
  data() {
    return {
      parc: {},
      loading: true,
      isProjection: true
    };
  },
  computed: {
    ...mapGetters({
      isExploitant: "isExploitant",
      isDreal: "isDreal",
      isParc: "isParc"
    }),
    parcIdQueryParam() {
      return String(this.$route.query.parcId);
    }
  },
  created() {
    this.getParcById();
  },
  methods: {
    getParcById() {
      this.loading = true;
      this.$store.dispatch("clearSelectedParcProfile");
      Promise.all([
        parcService.getParcById(this.parcIdQueryParam),
        aerogenerateurService.getAerogenerateursParc(this.parcIdQueryParam),
        posteLivraisonService.getPosteLivraisonsParc(this.parcIdQueryParam)
      ])
        .then(results => {
          if (results[0] && results[1] && results[2]) {
            this.parc = results[0];

            const eoliennes = results[1].sort((a, b) => {
              return this.sortByStringIdsAsc(a.id, b.id, '_E');
            });
            const postesLivraison = results[2].sort((a, b) => {
              return this.sortByStringIdsAsc(a.id, b.id, '_PL')
            });
            this.$store.dispatch("saveSelectedParcProfile", {
              parc: this.parc,
              eoliennes: eoliennes,
              postesLivraison: postesLivraison
            });

          }
          this.loading = false;

          this.checkProjection();
        })
        .catch(err => {
          console.log(err);
        });
    },
    reloadParc() {
      this.getParcById();
      console.log("Parc reloaded");
    },
    sortByStringIdsAsc(aId, bId, splitString) {
      aId = aId.split(splitString);
      aId = parseInt(aId[aId.length - 1]);

      bId = bId.split(splitString);
      bId = parseInt(bId[bId.length - 1]);

      return aId > bId ? 1 : -1;
    },
    checkProjection() {
      if (!(this.parc.projection && this.parc.projection.epsg)) {
        this.isProjection = false;
      } else {
        this.isProjection = true;
      }
    },
  }
};
</script>
<style></style>
